if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = this.activeCart();
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        // Firefox on touch devices can emit a second click after the add has
        // already finished. Ignore it so one tap cannot add the product twice.
        if (this.blockSubmitUntil && Date.now() < this.blockSubmitUntil) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // Logo-only landing pages leave a plain <cart-drawer> in the DOM and
        // hide it. It has no cart API, so calling it throws before /cart/add.js
        // and the button stays stuck in the loading state.
        this.cart = this.activeCart();
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        let added = false;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            added = true;

            if (!this.cart) {
              this.openAlternateCart();
              return;
            }
            const quickAddModal = this.closest('quick-add-modal');
            const showCart = () => {
              try {
                this.cart.renderContents(response);
              } catch (error) {
                console.error(error);
                if (typeof this.cart.open === 'function') this.cart.open();
              }
            };
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(showCart);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              showCart();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (added) this.blockSubmitUntil = Date.now() + 500;
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      activeCart() {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cart || typeof cart.getSectionsToRender !== 'function' || typeof cart.renderContents !== 'function') {
          return null;
        }
        if (getComputedStyle(cart).display === 'none') return null;
        return cart;
      }

      openAlternateCart() {
        const openCart = window.AMP_API && window.AMP_API.OPEN_CART;
        if (typeof openCart !== 'function') {
          window.location = window.routes.cart_url;
          return;
        }

        // Wait out the extra click Firefox sends after a tap. If the drawer
        // opens under that click, its overlay closes immediately.
        window.setTimeout(() => {
          Promise.resolve(openCart())
            .then(() => this.revealAmpCart())
            .catch((error) => {
              console.error(error);
              window.location = window.routes.cart_url;
            });
        }, 400);
      }

      revealAmpCart() {
        const root = document.querySelector('.amp-cart');
        const inner = document.querySelector('.amp-cart-drawer__inner');
        if (!root) return;

        root.classList.add('amp-cart--open');
        root.style.setProperty('transition', 'none', 'important');
        root.style.setProperty('visibility', 'visible', 'important');
        if (inner) {
          inner.style.setProperty('transition', 'none', 'important');
          inner.style.setProperty('transform', 'translateX(0)', 'important');
        }

        requestAnimationFrame(() => {
          root.style.removeProperty('transition');
          root.style.removeProperty('visibility');
          if (inner) {
            inner.style.removeProperty('transition');
            inner.style.removeProperty('transform');
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
